import angular from 'angular';
import myLoansMobileFiltersComponent from './myLoansMobileFilters.component';

let myLoansMobileFiltersModule = angular.module('myLoansMobileFilters', [
])

.component('myLoansMobileFilters', myLoansMobileFiltersComponent)

.name;

export default myLoansMobileFiltersModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansMobileFilters/myLoansMobileFilters.js